export const getJobs = state => {
  return state.jobs.get('jobs')
}

export const getProgressJobs = state => {
  return state.jobs.get('progressJobs')
}
